var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 47,
    viewBox: "0 0 37 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2135_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 37,
    height: 38
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1014 41.9915H2.89862C1.36406 41.9915 0 40.6259 0 39.0896V7.85205C0 6.31577 1.36406 4.9502 2.89862 4.9502H34.1014C35.6359 4.9502 37 6.31577 37 7.85205V39.0896C37 40.6259 35.6359 41.9915 34.1014 41.9915Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2135_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 4.77948V41.8208H37V4.77948H0ZM23.871 11.6074H13.129C12.2765 11.6074 11.765 10.9246 11.765 10.2418C11.765 9.559 12.2765 8.87621 13.129 8.70551H16.5392C16.5392 7.68133 17.3917 6.82785 18.4147 6.82785C19.4378 6.82785 20.2903 7.68133 20.2903 8.70551H23.7005C24.553 8.70551 25.0645 9.3883 25.0645 10.2418C25.0645 11.0953 24.7235 11.6074 23.871 11.6074Z",
    fill: "#4285F4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2135_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 37,
    height: 38
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.1014 41.9915H2.89862C1.36406 41.9915 0 40.6259 0 39.0896V7.85205C0 6.31577 1.36406 4.9502 2.89862 4.9502H34.1014C35.6359 4.9502 37 6.31577 37 7.85205V39.0896C37 40.6259 35.6359 41.9915 34.1014 41.9915Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2135_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.1014 4.77948H2.89862C1.36406 4.77948 0 6.14506 0 7.68133V8.02273C0 6.48645 1.36406 5.12087 2.89862 5.12087H34.1014C35.6359 5.12087 37 6.48645 37 8.02273V7.85203C37 6.14506 35.6359 4.77948 34.1014 4.77948Z",
    fill: "white",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2135_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 37,
    height: 38
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.1014 41.9915H2.89862C1.36406 41.9915 0 40.6259 0 39.0896V7.85205C0 6.31577 1.36406 4.9502 2.89862 4.9502H34.1014C35.6359 4.9502 37 6.31577 37 7.85205V39.0896C37 40.6259 35.6359 41.9915 34.1014 41.9915Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2135_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0 4.77948V13.485H37V4.77948H0ZM23.871 11.6074H13.129C12.2765 11.6074 11.765 10.9246 11.765 10.2418C11.765 9.559 12.2765 8.87621 13.129 8.70551H16.5392C16.5392 7.68133 17.3917 6.82785 18.4147 6.82785C19.4378 6.82785 20.2903 7.68133 20.2903 8.70551H23.7005C24.553 8.70551 25.0645 9.3883 25.0645 10.2418C25.0645 11.0953 24.7235 11.6074 23.871 11.6074Z",
    fill: "#3F51B5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2135_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 37,
    height: 38
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.1014 41.9915H2.89862C1.36406 41.9915 0 40.6259 0 39.0896V7.85205C0 6.31577 1.36406 4.9502 2.89862 4.9502H34.1014C35.6359 4.9502 37 6.31577 37 7.85205V39.0896C37 40.6259 35.6359 41.9915 34.1014 41.9915Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2135_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M23.871 11.7781H13.1291C12.447 11.7781 11.765 11.0953 11.765 10.4125V10.5832C11.765 11.4367 12.447 11.9488 13.1291 12.1195H24.0415C24.894 12.1195 25.4056 11.4367 25.4056 10.5832V10.4125C25.2351 11.0953 24.7235 11.6074 23.871 11.7781Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2135_471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 37,
    height: 38
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.1014 41.9915H2.89862C1.36406 41.9915 0 40.6259 0 39.0896V7.85205C0 6.31577 1.36406 4.9502 2.89862 4.9502H34.1014C35.6359 4.9502 37 6.31577 37 7.85205V39.0896C37 40.6259 35.6359 41.9915 34.1014 41.9915Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2135_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.2,
    d: "M23.871 8.53483H20.4609C20.4609 7.51065 19.6083 6.65717 18.5853 6.65717C17.5622 6.65717 16.7097 7.51065 16.7097 8.53483H13.1291C12.2765 8.53483 11.765 9.21762 11.765 10.0711V10.2418C11.765 9.55902 12.447 8.87623 13.1291 8.87623H16.5392C16.5392 7.85205 17.3917 6.99856 18.4148 6.99856C19.4378 6.99856 20.2904 7.85205 20.2904 8.87623H23.7005C24.3825 8.87623 25.0646 9.55902 25.0646 10.2418V10.0711C25.2351 9.21762 24.7235 8.53483 23.871 8.53483Z",
    fill: "#1A237E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.1014 41.6501H2.89862C1.36406 41.6501 0 40.2845 0 38.7482V38.9189C0 40.4552 1.36406 41.8208 2.89862 41.8208H34.1014C35.6359 41.8208 37 40.4552 37 38.9189V38.7482C37 40.2845 35.6359 41.6501 34.1014 41.6501Z",
    fill: "#1A237E",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.89862 5.12089H34.1014C35.6359 5.12089 37 6.48647 37 8.02274V7.85205C37 6.31577 35.6359 4.9502 34.1014 4.9502H2.89862C1.36406 4.9502 0 6.31577 0 7.85205V8.02274C0 6.48647 1.36406 5.12089 2.89862 5.12089Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27.2811 28.165L18.0738 18.9474C17.7327 18.606 17.3917 18.4353 17.0507 18.4353H10.742C9.88943 18.4353 9.2074 19.1181 9.2074 19.9716V26.2874C9.2074 26.6288 9.3779 27.1409 9.71892 27.3116L18.9263 36.5292C19.2673 36.8706 19.6083 37.0413 19.9493 37.0413C20.2903 37.0413 20.8019 36.8706 20.9724 36.5292L27.2811 30.2134C27.6221 29.872 27.7927 29.5306 27.7927 29.1892C27.7927 28.8478 27.6221 28.5064 27.2811 28.165ZM11.5945 21.8492C11.083 21.8492 10.5715 21.3372 10.5715 20.8251C10.742 20.4837 11.083 19.9716 11.5945 19.9716C12.106 19.9716 12.6175 20.4837 12.6175 20.9958C12.6175 21.5079 12.2765 21.8492 11.5945 21.8492Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.2,
    d: "M27.2811 28.165L18.0738 18.9474C17.7327 18.606 17.3917 18.4353 17.0507 18.4353H10.742C9.88943 18.4353 9.2074 19.1181 9.2074 19.9716V20.1423C9.2074 19.2888 9.88943 18.606 10.742 18.606H17.0507C17.3917 18.606 17.9032 18.7767 18.0738 19.1181L27.2811 28.3357C27.4516 28.5064 27.6221 28.8478 27.6221 29.1892V29.0185C27.7927 28.8478 27.6221 28.5064 27.2811 28.165ZM11.5945 21.8492C12.106 21.8492 12.6175 21.3372 12.6175 20.8251V20.6544C12.6175 21.1665 12.106 21.5078 11.5945 21.5078C11.083 21.5078 10.742 21.3372 10.742 20.8251V20.9958C10.742 21.5079 11.083 21.8492 11.5945 21.8492Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.2,
    d: "M11.5945 20.1423C12.106 20.1423 12.447 20.4836 12.6175 20.9957V20.825C12.6175 20.4836 12.2765 19.9716 11.5945 19.9716C11.083 19.9716 10.742 20.4836 10.742 20.9957V21.1664C10.742 20.6543 11.2535 20.1423 11.5945 20.1423ZM27.2811 30.2134L20.9724 36.5292C20.6314 36.8706 20.2903 37.0413 19.9493 37.0413C19.6083 37.0413 19.0968 36.8706 18.9263 36.5292L9.71892 27.3115C9.3779 26.9701 9.2074 26.6287 9.2074 26.2874V26.458C9.2074 26.7994 9.3779 27.3115 9.71892 27.4822L18.9263 36.6999C19.2673 37.0413 19.6083 37.212 19.9493 37.212C20.2903 37.212 20.8019 37.0413 20.9724 36.6999L27.2811 30.3841C27.6221 30.0427 27.7927 29.7013 27.7927 29.3599V29.1892C27.6221 29.7013 27.6221 30.0427 27.2811 30.2134Z",
    fill: "#1A237E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M37 37.8948L27.4516 28.3358C27.6221 28.5065 27.7927 28.8478 27.7927 29.1892C27.7927 29.5306 27.6221 30.0427 27.2811 30.2134L20.9724 36.5292C20.8019 36.8706 20.2904 37.0413 19.9493 37.0413C19.6083 37.0413 19.2673 36.8706 19.0968 36.6999L24.212 41.8208H37V37.8948Z",
    fill: "url(#paint0_linear_2135_471)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M37 38.9189V7.85205C37 6.31577 35.6359 4.9502 34.1014 4.9502H2.89862C1.36406 4.9502 0 6.31577 0 7.85205V39.0896C0 40.6259 1.36406 41.9915 2.89862 41.9915H34.1014C35.6359 41.9915 37 40.6259 37 38.9189ZM23.871 11.6074H13.129C12.2765 11.6074 11.765 10.9246 11.765 10.2418C11.765 9.55902 12.2765 8.87623 13.129 8.70553H16.5392C16.5392 7.68135 17.3917 6.82786 18.4147 6.82786C19.4378 6.82786 20.2903 7.68135 20.2903 8.70553H23.7005C24.553 8.70553 25.0645 9.38832 25.0645 10.2418C25.0645 11.0953 24.7235 11.6074 23.871 11.6074Z",
    fill: "url(#paint1_radial_2135_471)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2135_471",
    x1: 24.0492,
    y1: 33.3432,
    x2: 34.3985,
    y2: 43.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2135_471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.19355 5.34024) scale(49.528 49.5832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmc);
export default __webpack_public_path__ + "static/media/GMC.fda8d7be9e4301a7030722e6cc13b383.svg";
export { ForwardRef as ReactComponent };